import type { DeviationCategory } from '@/types';

import getDeviationCategory from '@/utils/helpers/get-deviation-category';

export const formatDeviation = (
  deviation: number,
  willStart: boolean
): { deviationTime: string; deviationCategory: DeviationCategory } => {
  const deviationMinutes = Math.round(deviation / 60);

  const deviationTime = deviationMinutes >= 0 ? `+${deviationMinutes}` : `${deviationMinutes}`;

  const deviationCategory = getDeviationCategory(deviation, willStart);

  return {
    deviationTime,
    deviationCategory,
  };
};
